export default "__VITE_ASSET__D_egUoaZ__"